<!-- @format -->

<company-info-form>
  <div class="contents">
    <section class="contents_area">
      <div class="container_heading">
        <h1 class="heading-01 heading_application">登録情報変更手続き</h1>
        <ul class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="{ routes.makePath('top-tag') }" class="home">ホーム</a>
          </li>
          <li class="breadcrumb-item"><a onclick="{ props.onFirst }">会社情報</a></li>
          <li class="breadcrumb-item">登録情報変更手続き</li>
        </ul>
      </div>
      <!--/.container_heading-->

      <div class="lead_block">
        <p>
          下記フォームの内容を確認したうえで、変更が必要な箇所を入力し、「
          <strong>確認画面へ</strong>
          」ボタンをクリックしてください。
        </p>
      </div>
      <!--/.lead_block-->

      <div class="contents_block">
        <company-form
          params="{ props.params }"
          errors="{ props.errors }"
          prefs="{ props.prefs }"
          confirmation="{ props.confirmation }"
        ></company-form>
        <!--/.application_form-->
      </div>
      <!--/.contents_block-->
    </section>
    <!--/.contents_area-->
  </div>
  <!--/.contents-->

  <script>
    import routes from "@model/menu-routes.js";
    import form from "@tags/parts/company-form.riot";

    export default {
      components: {
        "company-form": form,
      },
      onBeforeMount(props, state) {
        this.routes = routes;
      },
    };
  </script>
</company-info-form>
